"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ShareExpiredProductError;
// eslint-disable-next-line no-unused-vars
function ShareExpiredProductError(code, message) {
  var instance = new Error(message);
  instance.message = message;
  instance.code = code;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, ShareExpiredProductError);
  }
  return instance;
}
ShareExpiredProductError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
if (Object.setPrototypeOf) {
  Object.setPrototypeOf(ShareExpiredProductError, Error);
} else {
  ShareExpiredProductError.__proto__ = Error;
}